import React, {memo, useCallback} from "react";
import {useHistory, useLocation} from "react-router-dom";

import {buildBackNavigationFallback, getBackNavigationDescriptor} from "helpers/backNavigation";

export const useBackNavigation = ({ link, preserveState } = {}) => {
    const history = useHistory();
    const location = useLocation();

    return useCallback(() => {
        if (link) {
            if (preserveState && location.state) {
                history.push(link, location.state);
            } else {
                history.push(link);
            }

            return;
        }

        const backNavigation = getBackNavigationDescriptor(location.state);

        if (backNavigation) {
            const fallbackLocation = buildBackNavigationFallback(backNavigation);

            if (fallbackLocation) {
                history.replace(fallbackLocation);

                return;
            }
        }

        history.goBack();
    }, [history, link, location, preserveState]);
};

export const BackButton = memo(({ link, preserveState }) => {
    const goBack = useBackNavigation({ link, preserveState });

    return (
        <button
            onClick={goBack}
            className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back"
        />
    );
});
